// Auto-generated translation for sk.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:20:19.548494+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Pre majiteľov koní",
    title: "Všetko pre vášho koňa. V jednej aplikácii.",
    subtitle: "Spravujte zdravie, tréning, plánovanie a odborníkov z jedného prehľadného záznamu.",
    primaryCTA: {
      label: "Začať zadarmo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil koňa — hmotnosť, očkovanie, EquiCoach, výživa a tréning na jednej obrazovke",
      caption: "Váš kôň, kompletne na dosah.",
    },
    problem: "Termíny, fotografie, tréning, výživa a zdravie máte pravdepodobne roztrúsené po skupinách WhatsApp, škatuliach a rôznych aplikáciách. To spôsobuje stratu prehľadu.",
    solution: "EquiSight premení vášho koňa na jeden kompletný digitálny záznam, ktorý máte vždy so sebou.",
    benefits: [
      "Jeden kompletný profil pre každého koňa",
      "Zdravie, kováč, zubár a fyzioterapeut na jednom mieste",
      "Kalendár s inteligentnými pripomienkami",
      "Fotografie, poznámky a história bez obmedzenia",
      "Záloha všetkých vašich dát v Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 kôň · vždy zadarmo",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Viacero koní + záloha",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení začať?",
      title: "Začnite dnes so svojím prvým koňom.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Viac koní. Väčší prehľad. Väčšia istota.",
    subtitle: "Prejdite na Premium a spravujte všetkých svojich koní bez obmedzení — s plnou inteligenciou EquiCoach.",
    primaryCTA: {
      label: "Začnite 14 dní zadarmo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Všetky ceny",
      href: "/#pricing",
    },
    audience: "Pre majiteľov, športových jazdcov a chovateľov koní s viacerými koňmi.",
    features: [
      "Neobmedzené pridávanie koní",
      "Kompletná história každého koňa",
      "Zálohovanie dát",
      "Rozšírené poznatky EquiCoach",
      "Inteligentné upozornenia a plánovanie",
      "Zdravie a tréning plne prepojené",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Menej ako €0,17 za deň",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Prejdite na Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Pre jazdcov v jazdiarni",
    title: "Zlepšujte sa, aj bez vlastného koňa.",
    subtitle: "Sledujte svoje lekcie, tréningy a pokrok v rámci EquiSight — za menej ako šálka kávy mesačne pre mamu alebo otca. Alebo za cenu chutnej zmrzliny so šľahačkou.",
    primaryCTA: {
      label: "Začať s Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ako to funguje?",
      href: "#features",
    },
    problem: "Ako jazdec v jazdiarni často nemáte vlastného koňa, no predsa chcete rásť a mať prehľad o svojich lekciách, cieľoch a koňoch, na ktorých jazdíte.",
    solution: "Funkcie pre jazdcov v jazdiarni sú štandardnou súčasťou Premium — sledujte svoj vlastný rozvoj a prezerajte si priradené jazdiarenské kone v režime iba na čítanie.",
    features: [
      "Zaznamenávanie tréningov",
      "Stanovenie cieľov",
      "Sledovanie pokroku",
      "Prezeranie jazdiarenských koní s menom a fotografiou",
      "Žiadny prístup k súkromným zdravotným údajom",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za mesiac · funkcie pre jazdcov v jazdiarni sú zahrnuté",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Staňte sa členom",
      title: "Začnite ako jazdec v jazdiarni.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Pre jazdectvá a stajne",
    title: "Sprístupnite svoje jazdectvo digitálne každému jazdcovi.",
    subtitle: "Dajte jazdcom väzbu s koňmi, lekciami a pokrokom — bez zdieľania citlivých údajov o stajni.",
    primaryCTA: {
      label: "Požiadať o prístup",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť moduly",
      href: "#features",
    },
    audience: "EquiSight pomáha jazdectvám a stajniam udržať jazdcov dlhšie zapojených a odlíšiť sa v digitálnom prostredí.",
    features: [
      "Sprístupnenie jazdeckých koní jazdcom",
      "Meno a fotografia ku každému koňovi",
      "Priradenie jazdcov ku koňom",
      "Prístup iba na čítanie pre citlivé údaje",
      "Centrálna história lekcií a tréningu",
      "Správa používateľov s rolami",
    ],
    benefits: [
      "Silnejšia väzba s jazdcami",
      "Profesionálnejší imidž",
      "Ďalšia digitálna služba pre členov",
      "Nový príjmový tok prostredníctvom používania aplikácie",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za mesiac · funkcionalita jazdectva zahrnutá pre jazdcov",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Aktivujte modul Jazdectvo.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modul chovu",
    title: "Kontrola nad cyklom, graviditou a vývojom žriebäťa.",
    subtitle: "Kompletný modul chovu pre majiteľov kobýl a chovateľov — od krytia po žriebä, v jednej časovej osi.",
    primaryCTA: {
      label: "Aktivovať modul chovu",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť funkcie",
      href: "#features",
    },
    audience: "Pre chovateľov, majiteľov kobýl a stajne spravujúce viacero kobýl.",
    features: [
      "Sledovanie cyklu",
      "Zaznamenávanie ruje",
      "Evidencia dátumov inseminácie",
      "Odpočítavanie do ultrazvukov",
      "Plánovanie kontrol gravidity",
      "Rodokmeň a pôvod",
      "Vývoj žriebäťa",
      "Prehľad všetkých gravidných kobýl",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Za mesiac · Modul chovu zahrnutý v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Začnite dnes",
      title: "Začnite so správou chovu.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modul kováč",
    title: "Pracujte múdrejšie ako kováč. Zaznamenajte všetko profesionálne.",
    subtitle: "Kalendár, fotografie, poznámky a história ošetrení v jednom module — menej nedorozumení, silnejší spis.",
    primaryCTA: {
      label: "Začať ako kováč",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Professional Bundel",
      href: "/professional",
    },
    audience: "Pre kováčov, ktorí chcú zlepšiť prehľad, dokumentáciu a komunikáciu s klientmi.",
    features: [
      "Vlastný kalendár",
      "Stretnutia podľa klienta",
      "Prezeranie profilov koní",
      "Pridávanie fotografií pred a po",
      "Zaznamenanie ošetrenia",
      "Zaznamenanie rád a poznámok",
      "Upozornenie ETA pre klienta: \"Kováč je na ceste\"",
    ],
    benefits: [
      "Profesionálnejšia práca",
      "Menej nedorozumení",
      "Lepšie budovanie spisu",
      "Silnejšia pozícia pri zodpovednosti",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za mesiac · Modul kováč zahrnutý v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Aktivujte modul Kováč.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modul zubného lekára",
    title: "Kompletná zubná dokumentácia pre každého koňa.",
    subtitle: "Zaznamenávajte nálezy, ošetrenia a sledovanie priamo v EquiSight.",
    primaryCTA: {
      label: "Začať ako konský zubný lekár",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Professional balík",
      href: "/professional",
    },
    audience: "Konský zubní lekári, veterinári a praxe, ktoré chcú pracovať štruktúrovane.",
    features: [
      "Zaznamenať kontrolu chrupu",
      "Nálezy pri každom ošetrení",
      "Pridať fotografie",
      "Správa pre majiteľa",
      "Odporúčania pre sledovanie",
      "História každého koňa",
      "Naplánovať nový termín",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za mesiac · Modul zubného lekára zahrnutý v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Aktivujte modul zubného lekára.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modul Fyzio / Osteo",
    title: "Sledujte telo, pohyb a regeneráciu profesionálne.",
    subtitle: "Pre fyzioterapeutov a osteopatov, ktorí chcú koňom poskytovať systematickú starostlivosť.",
    primaryCTA: {
      label: "Začať ako fyzio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Professional balík",
      href: "/professional",
    },
    features: [
      "Vstupný formulár pre každého koňa",
      "Zaznamenávanie telesných nálezov",
      "Pridávanie fotografií a videí",
      "Vytvorenie správy o ošetrení",
      "Zdieľanie cvičení a následnej starostlivosti",
      "Sledovanie rehabilitačného procesu",
      "História každého koňa",
    ],
    benefits: [
      "Lepší prehľad v priebehu času",
      "Profesionálne reportovanie",
      "Jasná komunikácia s majiteľom, trénerom a jazdcom",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za mesiac · Modul Fyzio / Osteo je súčasťou Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Aktivujte modul Fyzio / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modul tréner",
    title: "Koučujte jazdcov s dátami, cieľmi a pokrokom.",
    subtitle: "Urobte tréning merateľným a vedenie profesionálnejším — pre jedného alebo viacerých jazdcov.",
    primaryCTA: {
      label: "Začať ako tréner",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Pro balík",
      href: "/#pricing",
    },
    audience: "Pre inštruktorov, trénerov a koučov s viacerými jazdcami alebo koňmi.",
    features: [
      "Prepojiť jazdcov",
      "Sledovať kone",
      "Nastaviť tréningové ciele",
      "Poskytovať spätnú väzbu",
      "Analyzovať výsledky zo súťaží",
      "Zobraziť pokrok pre každú kombináciu",
      "Využívať analýzy protokolov na zameranie tréningu",
    ],
    benefits: [
      "Lepšie vedenie",
      "Väčšia štruktúra",
      "Profesionálnejšia komunikácia",
      "Pevnejší vzťah s klientmi",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Za mesiac · Modul tréner zahrnutý v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Aktivujte modul Tréner.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analýza súťaží",
    title: "Od protokolu k zlepšeniu výkonu.",
    subtitle: "Nahrajte svoj súťažný protokol a objavte, kde strácate body — nielen sledujte svoje skóre, ale pochopte, ako sa zlepšiť.",
    primaryCTA: {
      label: "Analyzujte svoj prvý protokol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť Premium",
      href: "/premium",
    },
    features: [
      "Nahranie fotografie protokolu",
      "Spracovanie prednej a zadnej strany",
      "Rozpoznanie triedy, čísla jazdy a rozhodcu",
      "Analýza skóre podľa jednotlivých prvkov",
      "Zhrnutie komentárov",
      "Zobrazenie silných a slabých stránok",
      "Trendy podľa kombinácie kôň-jazdec",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za mesiac · analýza súťaží zahrnutá od verzie Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravení?",
      title: "Začnite s analýzou súťaží.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional balíček",
    title: "Pre profesionálov v oblasti koní.",
    subtitle: "Kováč, zubár, fyzioterapeut, osteopat alebo tréner: spolupracujte v jednom digitálnom dosiari koňa.",
    primaryCTA: {
      label: "Začať ako profesionál",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobraziť jednotlivé moduly",
      href: "#features",
    },
    audience: "Professional balíček kombinuje všetky odborné moduly v jednom predplatnom.",
    features: [
      "Modul kováča",
      "Modul zubára",
      "Modul fyzio / osteo",
      "Kalendár a správa klientov",
      "Profily koní a reporty",
      "História liečby a budovanie dosiara",
      "Komunikácia s majiteľom",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za mesiac · všetky odborné moduly zahrnuté",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravený?",
      title: "Vyberte si Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Tiesňové čísla pre koňa",
    title: "Vždy správna pomoc na dosah ruky.",
    subtitle: "V núdzovej situácii záleží každá sekunda. S EquiSight máte všetky dôležité kontaktné údaje vášho koňa okamžite po ruke — jedno ťuknutie a voláte.",
    primaryCTA: {
      label: "Pripravte si svoje núdzové kontakty",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Začnite s EquiSight zadarmo",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Núdzové kontakty — priame volanie, WhatsApp alebo navigácia k veterinárovi, klinike a podkovárovi",
      caption: "Jedno ťuknutie. Žiadna panika.",
      embeddedFrame: true,
    },
    problem: "Váš kôň má problém — kolika, zranenie, panika. A potom začína hľadanie. Koho zavolať? Máte správne číslo? Je to pohotovostné číslo? Drahocenný čas sa stráca.",
    solution: "S EquiSight máte všetko okamžite po ruke. Žiadne hľadanie. Žiadne pochybnosti. Jedno ťuknutie a ste v kontakte.",
    scenario: {
      title: "Predstavte si — váš kôň vykazuje príznaky koliky.",
      steps: [
        "Otvoríte EquiSight",
        "Ťuknete na \"Veterinár\"",
        "Priamo voláte",
      ],
      tagline: "Žiadny stres. Žiadne hľadanie. Len akcia.",
    },
    features: [
      "Všetky núdzové čísla na jednom mieste",
      "Volanie jedným ťuknutím priamo z aplikácie",
      "WhatsApp jedným ťuknutím",
      "Priama navigácia na adresu",
      "Vlastný zoznam kontaktov pre každého koňa",
      "Veterinár, klinika, podkovár, zubár, fyzioterapeut",
      "Adresa a popis trasy okamžite k dispozícii",
      "Označte obľúbené čísla hviezdičkou",
      "Pohotovostné čísla (112, 144) vždy navrchu",
    ],
    benefits: [
      "Pokoj a kontrola v núdzovej situácii",
      "Všetci v stajni majú rovnaké čísla po ruke",
      "Žiadne zabudnuté vizitky",
      "Reagujte o sekundy rýchlejšie pri pohotovosti",
    ],
    audience: "Pre majiteľov koní, ošetrovateľov, trénerov a stajne — každého, kto je zodpovedný za koňa.",
    showcase: {
      eyebrow: "Vopred pripravené pre vás",
      title: "13 kategórií kontaktov — pripravených na vyplnenie.",
      description: "Od veterinára a pohotovostnej kliniky až po sedlára, inštruktora a správcu pastviny. EquiSight pozná váš svet a vopred pripraví správne kontaktné polia. Ťuknite, vyplňte, hotovo.",
      bullets: [
        "Pohotovosť a zdravie — veterinár, pohotovosť, klinika, linka otráv",
        "Každodenná starostlivosť — podkovár, zubár, fyzioterapeut, inštruktor",
        "Stajňa a pastvina — správca stajne, správca pastviny, penzión",
        "Krmivo a materiály — dodávatelia sena, jadrového krmiva, slamy",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Obrazovka správy núdzových kontaktov — všetky navrhované kontakty podľa kategórie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Kontrolný zoznam núdzových čísel pre koňa",
      items: [
        "Veterinár",
        "Pohotovostná klinika (24/7)",
        "Záchranná služba pre zvieratá · 144",
        "Podkovár",
        "Náhradná kontaktná osoba",
        "Všeobecné tiesňové číslo · 112",
      ],
      cta: {
        label: "Otvoriť v EquiSight a okamžite vyplniť",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Núdzové čísla",
          price: "Gratis",
          note: "Vždy zadarmo · pre každého, v každom predplatnom",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Uistite sa, že ste pripravení",
      title: "Skôr, než to bude potrebné.",
      href: "/#waitlist",
    },
    microcopy: [
      "Bez záväzkov",
      "Nastavenie do 2 minút",
      "Kedykoľvek upraviteľné",
    ],
  },
};

export default LANDINGS;
